import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { createUser } from "../../../api/user";
import { Icon } from "../../../components/Component";
import { UserSchema } from "../../../validations/UserValidation";

const AddUserModal = ({ modalForm, setModalForm, mutation }) => {
  const [passState, setPassState] = useState(false);
  const [confirmPassState, setConfirmPassState] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(UserSchema),
    defaultValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      role: "user",
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await createUser({
        name: data.name,
        email: data.email,
        password: data.password,
        confirmPassword: data.confirmPassword,
        role: data.role,
      });
      reset({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
      });
      mutation();

      toast.success(response?.data?.message, {
        position: "top-center",
      });
      toggleForm();
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    reset({
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    });
  }, [modalForm]);

  const toggleForm = () => setModalForm(!modalForm);

  return (
    <Modal isOpen={modalForm}>
      <ModalHeader
        toggle={toggleForm}
        close={
          <button className="close" onClick={toggleForm}>
            {/* <Icon name="cross" /> */}
          </button>
        }
      >
        Add User
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label" htmlFor="full-name">
              Name
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className={`form-control ${errors.name ? "error" : ""}`}
                id="full-name"
                placeholder="Enter your name"
                {...register("name", {
                  setValueAs: (value) => value.trim(),
                })}
              />
              {errors.name && (
                <span className="custom-invalid">{errors.name.message}</span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className={`form-control ${errors.email ? "error" : ""}`}
                id="email"
                placeholder="Enter your email"
                {...register("email", {
                  setValueAs: (value) => value.trim(),
                })}
              />
              {errors.email && (
                <span className="custom-invalid">{errors.email.message}</span>
              )}
            </div>
          </div>
          <div className="form-group">
            <Label>Password</Label>
            <div className="form-control-wrap">
              <a
                href="#password"
                onClick={(ev) => {
                  ev.preventDefault();
                  setPassState(!passState);
                }}
                className={`form-icon form-icon-right passcode-switch ${
                  passState ? "is-hidden" : "is-shown"
                }`}
              >
                <Icon name="eye" className="passcode-icon icon-show"></Icon>
                <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
              </a>
              <input
                type={passState ? "text" : "password"}
                id="password"
                {...register("password", {
                  setValueAs: (value) => value.trim(),
                })}
                placeholder="Enter your password"
                className={`form-control ${errors.password ? "error" : ""}`}
              />
              {errors.password && (
                <span className="custom-invalid">
                  {errors.password.message}
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <Label>Confirm password</Label>
            <div className="form-control-wrap">
              <a
                href="#confirmPassword"
                onClick={(ev) => {
                  ev.preventDefault();
                  setConfirmPassState(!confirmPassState);
                }}
                className={`form-icon form-icon-right passcode-switch ${
                  confirmPassState ? "is-hidden" : "is-shown"
                }`}
              >
                <Icon name="eye" className="passcode-icon icon-show"></Icon>
                <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
              </a>
              <input
                type={confirmPassState ? "text" : "password"}
                id="confirmPassword"
                {...register("confirmPassword", {
                  setValueAs: (value) => value.trim(),
                })}
                placeholder="Enter your confirm password"
                className={`form-control ${
                  errors.confirmPassword ? "error" : ""
                }`}
              />
              {errors.confirmPassword && (
                <span className="custom-invalid">
                  {errors.confirmPassword.message}
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Role</label>
            <ul className="custom-control-group g-3 align-center">
              <li>
                <div className="custom-control custom-radio custom-control-pro no-control checked">
                  <input
                    type="radio"
                    className="custom-control-input"
                    {...register("role")}
                    value="user"
                    id="btnRadio1"
                    defaultChecked
                  />
                  <label className="custom-control-label" htmlFor="btnRadio1">
                    User
                  </label>
                </div>
              </li>
              <li>
                <div className="custom-control custom-radio custom-control-pro no-control checked">
                  <input
                    type="radio"
                    className="custom-control-input"
                    {...register("role")}
                    value="admin"
                    id="btnRadio2"
                  />
                  <label className="custom-control-label" htmlFor="btnRadio2">
                    Admin
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <Row className="justify-content-end mx-auto">
            <Col className="col-auto px-0">
              <div className="form-group">
                <div className="d-flex justify-content-end pt-5">
                  <Button
                    color="white"
                    size="lg"
                    onClick={toggleForm}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Col>
            <Col className="col-auto px-0">
              <div className="form-group">
                <div className="d-flex justify-content-end pt-5">
                  <Button
                    color="primary"
                    type="submit"
                    size="lg"
                    disabled={loading}
                  >
                    {loading ? <Spinner size={"sm"} /> : "Create User"}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default AddUserModal;
